import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { GetSqsMessageResponseInfoInner } from '@/coreInfrastructureModule/axios/generated/sqsAccessManage/api';
import { ISqsAccessManageRepository } from '@/coreInfrastructureModule/interfaces/ISqsAccessManageRepository';

/**
 * SQSをトリガーとする処理の進行状況一覧をDynamoDBから取得するユースケース
 */
export class GetSqsMessageUseCase {
  /**
   * SQSをトリガーとする処理の進行状況一覧をDynamoDBから取得する
   * @param repository - SQSをトリガーとする処理の進行状況一覧をDynamoDBから取得する責務を負うクラス
   */
  static async execute(repository: ISqsAccessManageRepository): Promise<INetworkResult<GetSqsMessageResponseInfoInner[], Error>> {
    try {
      const result = await repository.get();

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
